
function getProductImages(sectionId) {
  const dataScript = document.getElementById(`ProductImagesData-${sectionId}`);
  if (!dataScript) return [];
  try {
    return JSON.parse(dataScript.textContent || '[]');
  } catch (error) {
    return [];
  }
}

function updateProductLightbox(lightbox, nextIndex) {
  if (!lightbox || !Array.isArray(lightbox._images) || !lightbox._images.length) return;
  const images = lightbox._images;
  const normalizedIndex = (nextIndex + images.length) % images.length;
  lightbox.dataset.currentIndex = normalizedIndex;
  const modalImage = lightbox.querySelector('.product-lightbox-image');
  if (modalImage) {
    modalImage.src = images[normalizedIndex].src;
    modalImage.alt = images[normalizedIndex].alt || '';
  }
}

function closeProductLightbox(lightbox) {
  if (!lightbox) return;
  lightbox.hidden = true;
  lightbox.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}
document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const flowImageButton = event.target.closest('.product-flow-image-button');
  if (flowImageButton) {
    const sectionId = flowImageButton.dataset.sectionId;
    const lightboxId = flowImageButton.dataset.lightboxTarget;
    const lightbox = document.getElementById(lightboxId);
    const images = getProductImages(sectionId);
    const imageId = flowImageButton.dataset.imageId;
    const index = Math.max(0, images.findIndex((image) => String(image.id) === String(imageId)));

    if (lightbox && images.length) {
      lightbox._images = images;
      lightbox.dataset.currentIndex = index;
      const modalImage = lightbox.querySelector('.product-lightbox-image');
      if (modalImage) {
        modalImage.src = images[index].src;
        modalImage.alt = images[index].alt || '';
      }
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    return;
  }

  const lightboxClose = event.target.closest('.product-lightbox-close');
  if (lightboxClose) {
    closeProductLightbox(lightboxClose.closest('.product-lightbox'));
    return;
  }

  const lightboxNav = event.target.closest('.product-lightbox-nav');
  if (lightboxNav) {
    const lightbox = lightboxNav.closest('.product-lightbox');
    const currentIndex = Number(lightbox.dataset.currentIndex || 0);
    updateProductLightbox(lightbox, currentIndex + (lightboxNav.dataset.direction === 'prev' ? -1 : 1));
    return;
  }

  const openLightbox = event.target.closest('.product-lightbox');
  if (openLightbox && event.target === openLightbox) {
    closeProductLightbox(openLightbox);
    return;
  }

  const thumb = event.target.closest('.product-thumb');
  if (!thumb) return;
  const gallery = thumb.parentElement;
  const panel = thumb.closest('.product-media-panel');
  const mainImage = panel ? panel.querySelector('.product-main-image') : null;
  if (!mainImage) return;
  mainImage.src = thumb.dataset.imageSrc;
  mainImage.alt = thumb.dataset.imageAlt || mainImage.alt;
  gallery.querySelectorAll('.product-thumb').forEach((node) => node.classList.remove('is-active'));
  thumb.classList.add('is-active');
});


(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealTargets = document.querySelectorAll(
    '.hero-single-wrap, .section-heading-row, .product-grid, .beam-card, .newsletter-panel, .footer-grid, .collection-header, .page-content, .product-page-grid, .cart-page .glass-panel'
  );

  if (!revealTargets.length) return;

  revealTargets.forEach((element) => element.classList.add('reveal-on-scroll'));

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    revealTargets.forEach((element) => element.classList.add('is-visible'));
    return;
  }

  requestAnimationFrame(() => {
    document.documentElement.classList.add('reveal-ready');
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.14,
    rootMargin: '0px 0px -6% 0px'
  });

  revealTargets.forEach((element, index) => {
    element.style.transitionDelay = `${Math.min(index * 45, 220)}ms`;
    observer.observe(element);
  });
})();

(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (prefersReducedMotion || !canHover) return;

  const comet = document.querySelector('.cursor-comet');
  if (!comet) return;

  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;
  let renderX = mouseX;
  let renderY = mouseY;
  let lastParticleTime = 0;
  let isInside = false;

  const spawnParticle = (x, y) => {
    const particle = document.createElement('span');
    particle.className = 'comet-particle';
    particle.style.left = `${x}px`;
    particle.style.top = `${y}px`;
    particle.style.setProperty('--drift-x', `${(-12 - Math.random() * 22).toFixed(2)}px`);
    particle.style.setProperty('--drift-y', `${(-8 + Math.random() * 20).toFixed(2)}px`);
    particle.style.opacity = (0.28 + Math.random() * 0.34).toFixed(2);
    particle.style.width = particle.style.height = `${3 + Math.random() * 6}px`;
    particle.style.marginLeft = particle.style.marginTop = `${-(parseFloat(particle.style.width) / 2)}px`;
    document.body.appendChild(particle);
    particle.addEventListener('animationend', () => particle.remove(), { once: true });
  };

  const loop = () => {
    renderX += (mouseX - renderX) * 0.22;
    renderY += (mouseY - renderY) * 0.22;
    comet.style.transform = `translate3d(${renderX - 9}px, ${renderY - 9}px, 0)`;
    requestAnimationFrame(loop);
  };

  document.addEventListener('mousemove', (event) => {
    mouseX = event.clientX;
    mouseY = event.clientY;
    if (!isInside) {
      isInside = true;
      comet.classList.add('is-visible');
    }
    const now = performance.now();
    if (now - lastParticleTime > 18) {
      spawnParticle(event.clientX, event.clientY);
      if (Math.random() > 0.45) {
        spawnParticle(event.clientX - (4 + Math.random() * 10), event.clientY + (-4 + Math.random() * 8));
      }
      lastParticleTime = now;
    }
  }, { passive: true });

  document.addEventListener('mouseleave', () => {
    comet.classList.remove('is-visible');
    isInside = false;
  });

  window.addEventListener('blur', () => {
    comet.classList.remove('is-visible');
    isInside = false;
  });

  loop();
})();

document.addEventListener('keydown', (event) => {
  const lightbox = document.querySelector('.product-lightbox[aria-hidden="false"]');
  if (!lightbox) return;

  if (event.key === 'Escape') {
    closeProductLightbox(lightbox);
    return;
  }

  if (event.key === 'ArrowLeft') {
    updateProductLightbox(lightbox, Number(lightbox.dataset.currentIndex || 0) - 1);
  }

  if (event.key === 'ArrowRight') {
    updateProductLightbox(lightbox, Number(lightbox.dataset.currentIndex || 0) + 1);
  }
});


// --- v37: Keep Shopify/Printful variant prices and availability synced on product pages ---
(() => {
  const syncVariant = (form, select) => {
    if (!form || !select) return;

    const option = select.options[select.selectedIndex];
    if (!option) return;

    const sectionId = form.dataset.sectionId;
    const section = form.closest('.product-flow-section') || document;
    const price = document.getElementById(`ProductPrice-${sectionId}`) || section.querySelector('.product-detail-price');
    const submit = form.querySelector('.product-submit');
    const available = option.dataset.available === 'true';

    if (price && option.dataset.priceMoney) {
      price.textContent = option.dataset.priceMoney;
      price.dataset.price = option.dataset.price || '';
      price.dataset.comparePrice = option.dataset.comparePrice || '';
    }

    if (submit) {
      submit.disabled = !available;
      submit.textContent = available
        ? (submit.dataset.addToCartText || 'Add to Cart')
        : (submit.dataset.soldOutText || 'Sold Out');
    }

    // Keep browser URL aligned with the selected Shopify variant without reloading.
    if (window.history && window.history.replaceState && option.value) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    }

    // If Printful/Shopify assigned a specific image to the variant, bring it into view.
    const imageId = option.dataset.imageId;
    if (imageId) {
      const imageButton = section.querySelector(`.product-flow-image-button[data-image-id="${imageId}"]`);
      if (imageButton) {
        section.querySelectorAll('.product-flow-image-button').forEach((button) => button.classList.remove('is-selected-variant-image'));
        imageButton.classList.add('is-selected-variant-image');
      }
    }
  };

  const initVariantSync = () => {
    document.querySelectorAll('.product-form[data-product-form]').forEach((form) => {
      const select = form.querySelector('.product-variant-select[name="id"]');
      if (!select || select.dataset.farouttVariantSync === 'true') return;

      select.dataset.farouttVariantSync = 'true';
      syncVariant(form, select);
      select.addEventListener('change', () => syncVariant(form, select));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantSync);
  } else {
    initVariantSync();
  }
})();
